import { css, cva } from '@/styled-system/css';

export const accordionPanelRecipe = cva({
  base: {
    display: 'grid',
    overflow: 'hidden',
    position: 'relative',
    transitionProperty: {
      _motionReduce: 'none',
      _motionSafe: 'grid-template-rows',
    },
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '{durations.250}',
    },
    transitionTimingFunction: 'cubic-bezier(0.76, 0, 0.24, 1)',
  },
  variants: {
    open: {
      true: {
        gridTemplateRows: 'minmax(0, 1fr)',
      },
      false: {
        gridTemplateRows: 'minmax(0, 0fr)',
      },
    },
  },
});

export const accordionPanelStyles = css.raw({
  display: 'block',
  position: 'relative',
  minHeight: 0,
  overflow: 'hidden',
  paddingInline: 'default',
  paddingBlockStart: 'Accordion.Panel.padding.top',
  paddingBlockEnd: 'default',
  borderTopWidth: 'default',
  borderTopStyle: 'solid',
  borderTopColor: 'Accordion.Panel.border',
  backgroundColor: 'Accordion.Panel.bg',
  borderBottomLeftRadius: 'obj.default',
  borderBottomRightRadius: 'obj.default',
});
